import { Button, ButtonProps } from "@/components/ui/button";
import { CHECKOUT_URL } from "@/config/checkout";

interface CheckoutButtonProps extends Omit<ButtonProps, "asChild"> {
  /** Button text, when no children are given. */
  label?: string;
  /** Applied to the wrapping anchor, for grid and flex parents. */
  wrapperClassName?: string;
}

/**
 * The one way to send somebody to the checkout.
 *
 * It renders a real anchor, never a react-router Link. Link builds an in-app
 * route, so handing it an absolute URL produces a broken relative path
 * (/checkout/... on this domain) and the sale is simply lost, with no error
 * anywhere. Keeping every buy button on this component also means the
 * checkout URL, and the affiliate code inside it, exists in exactly one place.
 *
 * The link deliberately stays in the same tab: that is what a checkout is
 * expected to do, it survives popup blockers, and it does not strand a mobile
 * buyer in a second tab.
 */
const CheckoutButton = ({
  children,
  label = "Enroll Now",
  className = "",
  wrapperClassName = "",
  ...props
}: CheckoutButtonProps) => (
  <a href={CHECKOUT_URL} className={wrapperClassName} data-testid="checkout-link">
    <Button className={className} {...props}>
      {children ?? label}
    </Button>
  </a>
);

export default CheckoutButton;
